import { render, staticRenderFns } from "./index-hosting.vue?vue&type=template&id=5766a39a&"
import script from "./index-hosting.vue?vue&type=script&lang=js&"
export * from "./index-hosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports